import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  STATUS: {
    id: 'Status.status',
    defaultMessage: 'Status',
    description: '[Type: Label][Vis.: low] - Status link in main navigation',
  },
});

const Status = () => {
  const url = createURL('/tools/api_status/', { ut_source: 'header' });
  const title = t(COPY.STATUS);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.STATUS} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.STATUS} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Status;
export { Status };
